/**
 * @description options.isAssignable => overrides default result
 * @param {number} assigned
 * @param {[number]} myTeam
 * @param {{isAssignable: boolean | false, currentUserId?: number, canAssignTeam?: boolean}} options
 * @returns
 */
export const isContactAssignable = (assigned, myTeam = [], options = { isAssignable: false }) => {
  if (!assigned || options.isAssignable) {
    return true
  }

  if (Number(assigned) === Number(options.currentUserId)) {
    return true
  }

  if (options.canAssignTeam !== false && assigned && myTeam.includes(assigned)) {
    return true
  }

  return false
}
